
import { StoreModel } from '../store.model';
import { ConstructionType } from '../../types/domain/construction-data.types';

export const constructionTypesSelector = (state: StoreModel): ConstructionType[] => state.constructionData.constructionTypes;
